export enum RankQueryKeys {
	GetRankList = 'rank.getRankList',
	GetRankById = 'rank.getRankById',
	GetRankNames = 'rank.getRankNames',
	RANK_EXPERIENCE_SETTING = 'rank.experienceSetting',
}

export enum RankMutationKeys {
	CreateRank = 'rank.createRank',
	UpdateRank = 'rank.updateRank',
	DeleteRank = 'rank.deleteRank',
	UpdateRankUpRewards = 'rank.updateRankUpRewards',
}
